/**
 * The saving of the object will be converted into a string before being stored into the session storage.
 * @param {any} objectToSave The object that will be saved in the session storage.
 * @param {string} featureKey The feature key that will be saved into the session storage.
 */
export const saveSessionObject = (objectToSave, featureKey) => {
  const sessionStorage = window.sessionStorage;

  sessionStorage.setItem(featureKey, JSON.stringify(objectToSave));
};

/**
 * The fetching of the object saved in the session storage, it will convert the string back into an object using out of the box functionality.
 * @param {string} featureKey The feature key to extract the stored value in the session storage.
 */
export const fetchSessionObject = (featureKey) => {
  const sessionStorage = window.sessionStorage;

  return JSON.parse(sessionStorage.getItem(featureKey));
};

/**
 * Removes the saved session storage key.
 * if no string is passed to this util, it will clear entire session storage.
 * if "high level" string is passed, only clear data relate to that one.
 * @param {[string]|string} featureKeys The keys to remove from the session storage.
 */
export const clearSessionObject = (featureKeys) => {
  const sessionStorage = window.sessionStorage;
  const keys = typeof featureKeys === 'object' ? Object.values(featureKeys) : featureKeys;

  // Loop through the array and remove all the feature keys specified.
  if (Array.isArray(keys)) {
    // if array contains object or any nested object, convert array to have all key values of every objects (include nested ones) and contains no object
    // Assume the maxi levels of the nested object is two
    const newKeysArr = [];
    keys.forEach((keysItem) => {
      if (typeof keysItem === 'object') {
        // For two levels object and loop one level deeper
        Object.values(keysItem).forEach((key) => {
          if (typeof key === 'object') {
            Object.values(key).forEach((k) => {
              newKeysArr.push(k);
            });
          } else if (typeof key === 'string') {
            newKeysArr.push(key);
          }
        });
      } else if (typeof keysItem === 'string') {
        newKeysArr.push(keysItem);
      }
    });

    newKeysArr.forEach((featureKey) => {
      sessionStorage.removeItem(featureKey);
    });
  } else if (typeof keys === 'string') {
    // Remove only the item if the feature keys is a string instead of an array.
    sessionStorage.removeItem(featureKeys);
  } else if (typeof keys === 'undefined' || keys === null) {
    const widgetsReadyFromKentico = fetchSessionObject('Widgets.ready');

    sessionStorage.clear();

    // Kentico added session storage, which is always `true`. when all session storage is cleared, add back `Widgets.ready` with value `true` back.
    if (widgetsReadyFromKentico) {
      sessionStorage.setItem('Widgets.ready', widgetsReadyFromKentico);
    }
  }
};

/**
 * Saves a URL Parameter as a session object if it exists. Returns the value or null if undefined.
 * @param {string} param Name of URL Parameter
 * @param {string} featureKey The feature key that will be saved into session storage
 * @returns Value of parameter that is saved to session storage
 */
export const saveUrlParamAsSessionObjectIfExists = (param, featureKey) => {
  const objectToSave = new URLSearchParams(window.location.search).get(param);
  if (objectToSave) {
    saveSessionObject(objectToSave, featureKey);
    return objectToSave;
  }
  return null;
};
